const ProjectStatusHelper = class ProjectStatusHelper {
    statuses = [
        {name: 'Project', displayName: 'Project', slug: 'project', value: 0},
        {name: 'RFQ', displayName: 'RFQ', slug: 'rfq', value: 1},
        {name: 'Quote', displayName: 'Quote', slug: 'quote', value: 2},
        {name: 'Order', displayName: 'Order', slug: 'order', value: 3},
        {name: 'ProductionOrder', displayName: 'Production order', slug: 'production-order', value: 4},
    ]

    getTag = value => {
        let type = this._getStatus(value);
        return type ? this._createTag(type) : <React.Fragment/>;
    }

    getDisplayName = value => {
        let type = this._getStatus(value);
        return type ? type.displayName : '';
    }

    _getStatus = value => {
        if (Number.isInteger(value))
            return this.statuses.find(x => x.value === value);
        else
            return this.statuses.find(x => x.name === value);
    }

    _createTag = type => {
        return (
            <div className={`project-tag project-tag-${type.slug}`}>
                {__(type.displayName)}
            </div>
        )
    }
}

export default new ProjectStatusHelper()